import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


export interface ILinkData {
  url: string;
  linktext: string;
  linkDescription: string;
  additionalDescription: string;
  header: string
  actionButtonText?: string;
}

@Component({
  selector: 'app-execute-link-action-modal',
  templateUrl: './execute-link-action-modal.component.html',
  styleUrls: ['./execute-link-action-modal.component.scss']
})
export class ExecuteLinkActionModalComponent {

  visible = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public linkData: ILinkData,
    private dialogRef: MatDialogRef<any>,
    ) { }

  executeAction() {
    this.close(true);
  }


  close(result) {
    this.visible = false;
    this.dialogRef.close(result);
  }

}


